import { Check, Sparkles } from "lucide-react";
import { RazorpayButton } from "@/components/payments/Checkout";

const perDay = (p) => Math.round(p.credits / p.days * 10) / 10;

export const PlanCard = ({ plan, info, busy, setBusy, active }) => {
  const badge = plan.badge;
  const best = badge === "Best Value";
  return (
    <section data-testid={`plan-card-${plan.plan_id}`}
      className={`panel p-6 flex flex-col gap-4 relative transition-transform hover:-translate-y-1 ${badge ? (best ? "ring-2 ring-amber-400/70" : "ring-2 ring-primary/70") : ""}`}>
      {badge && (
        <span data-testid={`plan-badge-${plan.plan_id}`}
          className={`absolute -top-3 left-6 text-[11px] font-bold uppercase tracking-wider rounded-full px-3 py-1 ${best ? "bg-amber-400 text-black" : "brand-gradient text-white"}`}>
          {badge}
        </span>
      )}
      <div className="font-bold text-lg">{plan.name}</div>
      <div>
        <span className="text-4xl font-extrabold font-display" data-testid={`plan-price-${plan.plan_id}`}>{plan.display}</span>
        <span className="text-sm text-muted-foreground ml-1">{plan.currency}</span>
      </div>
      <ul className="space-y-2 text-sm flex-1">
        <li className="flex gap-2"><Sparkles className="h-4 w-4 text-primary shrink-0 mt-0.5" /><span data-testid={`plan-credits-${plan.plan_id}`}><b>{plan.credits.toLocaleString()}</b> AI generations</span></li>
        <li className="flex gap-2"><Check className="h-4 w-4 text-primary shrink-0 mt-0.5" />Valid for {plan.days} days (~{perDay(plan)}/day)</li>
        <li className="flex gap-2"><Check className="h-4 w-4 text-primary shrink-0 mt-0.5" />One-time payment, no auto-renew</li>
      </ul>
      <RazorpayButton plan={plan} info={info} busy={busy} setBusy={setBusy}
        label={active ? `Add ${plan.credits} more · ${plan.display}` : `Subscribe · ${plan.display}`} />
    </section>
  );
};

export const TrialCard = ({ total, usage }) => {
  const trial = usage.plan === "trial";
  return (
    <section data-testid="plan-card-trial" className="panel p-6 flex flex-col gap-4">
      <div className="font-bold text-lg">Free Trial</div>
      <div><span className="text-4xl font-extrabold font-display">Free</span><span className="text-sm text-muted-foreground ml-1">one time</span></div>
      <ul className="space-y-2 text-sm flex-1">
        <li className="flex gap-2"><Sparkles className="h-4 w-4 text-primary shrink-0 mt-0.5" /><span><b>{total}</b> AI generations</span></li>
        <li className="flex gap-2"><Check className="h-4 w-4 text-primary shrink-0 mt-0.5" />Every feature unlocked</li>
        <li className="flex gap-2"><Check className="h-4 w-4 text-primary shrink-0 mt-0.5" />No card needed</li>
      </ul>
      <div data-testid="trial-remaining" className="h-12 rounded-full border border-border flex items-center justify-center text-sm font-semibold">
        {trial ? `${usage.remaining} of ${total} left` : "Included with every account"}
      </div>
    </section>
  );
};
